import React, { useLayoutEffect, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { fetchBlogBySlug } from '../utils/apiService';

// Import Images
import imgBlodgone from '../assets/image/img-8.jpg';

const Blog = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        // Trigger animations for this section
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            // Refresh ScrollTrigger as content might have changed
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 800);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [blog]);

    useEffect(() => {
        const getBlog = async () => {
            setIsLoading(true);
            const result = await fetchBlogBySlug(slug);
            if (result && result.status && result.data) {
                setBlog(result.data);
            }
            setIsLoading(false);
        };

        if (slug) {
            getBlog();
        }
    }, [slug]);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return imgBlodgone; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    return (
        <div className="wrapper position-relative">
            <Header />
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1
                            className="title ml-11"
                            dangerouslySetInnerHTML={{ __html: `<span class="split-text effect-right">${isLoading ? 'Loading...' : (blog ? 'Blog Details' : 'Blog Not Found')}</span>` }}
                        />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <Link to="/bloglist" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Blog' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" style={{ color: 'var(--primary)' }} dangerouslySetInnerHTML={{ __html: (isLoading ? '...' : (blog ? blog.title : '')) }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <div className="tf-container">
                    <div className="row rg-30">
                        <div className="col-xl-12">
                            <div className="wg-details wg-blog-details mb-60">
                                <div className="details-content">
                                    {isLoading ? (
                                        <div className="text-center py-5">
                                            <p>Loading blog details...</p>
                                        </div>
                                    ) : blog ? (
                                        <>
                                            <div
                                                className="blog-title desc mb-20"
                                                dangerouslySetInnerHTML={{ __html: `<p>${blog.title}</p>` }}
                                            />
                                            <div className="image img-details mb-35 desc mb-20">
                                                <img
                                                    src={getImageUrl(blog.image)}
                                                    data-src={getImageUrl(blog.image)}
                                                    alt={blog.title}
                                                    className="lazyload"
                                                />
                                            </div>
                                            <div className="desc mb-40 px-lg-15">
                                                <div className="desc-flex flex g-20">
                                                    <span className="lh-30" dangerouslySetInnerHTML={{ __html: blog.description }}></span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-5">
                                            <p>Blog not found.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Blog;